module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c134e2adffa7d75c07dda2e2374987f5.png";